import { Card } from "react-bootstrap"
import { Box } from "@mui/material"
import AppLogo from "../../screens/AppLogo.jsx"
import { useSelector } from "react-redux"
import { selectWebsiteData } from "../../redux/general/selectors"
import { usePinnedSidebar } from "../../context/PinnedSidebarContext.js"
import { useLocalization } from "../../providers/LocalizationProvider.js"
import MenuIcon from "@mui/icons-material/Menu"

/**
 * Reusable page header bar with app logo, title, and optional right-side actions.
 * @param {Object} props
 * @param {string} props.title - The page title to display.
 * @param {React.ReactNode} [props.actions] - Optional right-side action buttons/elements.
 * @param {boolean} [props.showHamburger=true] - Whether to show the mobile hamburger toggle.
 * @param {boolean} [props.showLogo=true] - Whether to show the app logo.
 * @param {boolean} [props.translateTitle=true] - Whether to translate the title via voiceiiTags.
 * @returns {JSX.Element}
 */
const PageHeaderBar = ({
    title,
    actions,
    showHamburger = true,
    showLogo = true,
    translateTitle = true,
}) => {
    const websiteData = useSelector(selectWebsiteData)
    const primaryColor = websiteData?.primary_colour || "#000000"
    const hideLogoOnMobileModern = websiteData?.sidebar_type === "modern"
    const { toggleMobileSidebar } = usePinnedSidebar()
    const { voiceiiTags } = useLocalization()

    return (
        <Card.Header className="bg-white">
            {showHamburger && (
                <MenuIcon
                    className="d-lg-none"
                    onClick={toggleMobileSidebar}
                    style={{ fontSize: "20px", marginRight: "12px" }}
                />
            )}
            <Box
                flex={1}
                display="flex"
                alignItems="center"
                height={{ xs: "30px", md: "43px" }}
                justifyContent="space-between"
                className="e-table-header"
            >
                <Box className="e-table-logo d-flex align-items-center">
                    {showLogo && (
                        <Box
                            sx={
                                hideLogoOnMobileModern
                                    ? { display: { xs: "none", lg: "inline-flex" } }
                                    : { display: "inline-flex" }
                            }
                        >
                            <AppLogo />
                        </Box>
                    )}

                    {location.pathname == "/dashboard" && hideLogoOnMobileModern && (
                        <Box sx={{ display: { xs: "inline-flex", lg: "none" } }}>
                            <AppLogo />
                        </Box>
                    )}
                    <span className="fw-bold datatable-title" style={{ color: primaryColor }}>
                        {translateTitle ? voiceiiTags(title) : title}
                    </span>
                </Box>
                {actions && <Box className="d-flex align-items-center gap-2">{actions}</Box>}
            </Box>
        </Card.Header>
    )
}

export default PageHeaderBar
